import ls from 'local-storage';
import Vue from 'vue';
import { Icon, IconName } from '@travelata-libs/ui-kit';
import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import { updateToursData } from '@/js/common/Service/priceJumpService';
import sociomanticManager from '@/js/common/Domain/Service/sociomantic';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import getPropertyForTourClick from '@/js/common/components/tour-page/services/getPropertyForTourClick';
import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import IsExclusiveBlock from '@ve/components/hotel/isExclusiveBlock/desktop/isExclusiveBlock.vue';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import { getToursConfirmationType, processAdaptersTourProducts, getTourConfirmationType } from '@entities/tourProduct';
import { ConfirmationTypeIcon, isConfirmationTypeVisible } from '@entities/confirmationType';
import { isTravelataOperatorId } from '@entities/operator';
import { filterByBonusMiles, BonusMilesBadge, filterByMirCashback, MirCashbackBadge } from '@features/tourProduct/filterTourProducts';
import {
    RoomProviders,
    FreeCancellationLabel,
    buildProviderOffers,
    buildRoomProviders,
    createRoomProvidersTracking,
} from '@features/roomProviders';
import {
 events, bindings, defaults, computeds, viewModelComputeds
} from './commonFieldsTourProduct/commonFieldsTourProduct';
import SimilarToursSelectDesktop from '../similarToursSelectDesktop/SimilarToursSelectDesktop';
import generateObjectToutProductFromRender from './services/generateObjectToutProductFromRender';
import tourProductComponentTemplate from './tourProductComponentTemplate.html';
import RoomCategoryPhotos from './roomCategoryPhotos/RoomCategoryPhotos';

import '@/css/common/components/warranted-icon.scss';
import { ProductType } from '@ve/types/ProductType';

const roomProvidersRegistry = new Map();

/**
 * fix me: необходимо переписать - с введенией hotel offer(продажа только отельного номера)
 * основой становится - не tourproduct а hotelRoom, который схлопывает в себя эти сущьности
 */
@viewModelDecorator({
    defaults,
    computeds: viewModelComputeds
})
@extendDecorator({
    el: '<div class="HtlTr" itemprop="makesOffer" itemscope itemtype="http://schema.org/Offer"></div>',
    events,
    bindings,
    computeds,
})
export default class TourProductView extends Backbone.Epoxy.View {
    initialize(options) {
        if (options.collectionView) {
            this.collectionView = options.collectionView;
            this.hotelTrackingService = options.collectionView.parentView?.hotelTrackingService;

            this.initRenderListener();
            this.roomInfoDg = options.collectionView.roomInfoDg || null;
            this.render();
            const directFlight = options.collectionView.searchFormModel.get('directFlight').get('model') || null;
            this.model.set('directFlight', directFlight);
            const bonusMiles = options.collectionView.searchFormModel.get('bonusMiles')?.get('model') ?? false;
            this.model.set('bonusMiles', bonusMiles);
            const mirCashback = options.collectionView.searchFormModel.get('mirCashback')?.get('model') ?? false;
            this.model.set('mirCashback', mirCashback);
        }

        this.initMapStates();
        this.initViewModel();
    }

    initRenderListener() {
        const renderDebounce = _.debounce(this.render.bind(this), 1);

        this.listenTo(this.model, 'change', renderDebounce);
        this.listenTo(this.model.get('tour'), 'change', renderDebounce);
        this.listenTo(this.model.get('hotelOffer'), 'change', renderDebounce);
        this.listenTo(this.model.get('railwayTour'), 'change', renderDebounce);
    }

    initMapStates() {
        const product = this.model.get('product');
        this.viewModel.mapState('roomDescription', product);
        this.viewModel.mapState('product', this.model);
        this.viewModel.mapState('tourProducts', this.model);
        this.viewModel.mapState('similarProducts', this.model);
        this.viewModel.mapState('prepayments', this.collectionView.model.get('filterCriteria'));
    }

    initViewModel() {
        const groupedTourProducts = this.collectionView.model.get('groupedTourProducts');
        const block = this.collectionView.currentSearchModel?.get('block');
        const groupSearch = this.collectionView.searchFormModel?.get('touristGroup')?.get('model')?.get('touristsByRooms')?.length;

        this.viewModel.set('groupSearch', !!groupSearch);
        this.viewModel.set('groupedTourProducts', groupedTourProducts);
        this.viewModel.set('block', block);
        this.viewModel.set('currentTour', this.model);
        this.viewModel.set('id', this.model.get('id'));
        this.viewModel.set('beds', this.model.get('tour')?.get('room').beds);
    }

    openRoomInfo(e) {
        e.preventDefault();
        e.stopPropagation();

        this.collectionView.trigger('openRoomDescriptionDialog', this.model);

        const currentTargetClassList = e.currentTarget.classList;
        const paramsForRoomInfoAnalytic = {
            hotelPage: true,
        };
        if (currentTargetClassList.contains('js-open-tour-info-by-room-name')) {
            this.hotelTrackingService.showMoreRoomInfo({
                roomNameClick: true,
                ...paramsForRoomInfoAnalytic,
            });
        } else if (currentTargetClassList.contains('js-open-tour-info-by-room-photo')) {
            this.hotelTrackingService.showMoreRoomInfo({
                roomPhotoClick: true,
                ...paramsForRoomInfoAnalytic,
            });
        }
    }

    hideRoomDescription(event) {
        const owner = this.$el.find('.HtlTrItemOwner');

        owner.find('.roomDescription').slideUp();
        owner.removeClass('openedDescription');

        event.stopPropagation();
    }

    hotelOfferStatistic() {
        const dataLayerAnalistic = new DataLayerAnalytics();
        const hotelOffer = this.model.get('cheapestHotelOfferProduct').get('hotelOffer');
        dataLayerAnalistic.sendHotelOfferStatistic(hotelOffer);
    }

    getAdaptedProducts() {
        const tourProducts = this.model.get('tour') ? [this.model, ...this.model.get('similarProducts')] : this.model.get('similarProducts');
        const adaptedTourProducts = processAdaptersTourProducts(tourProducts);
        return adaptedTourProducts;
    }

    initConfirmation() {
        const tourConfirmationEl = this.el.querySelector('.js-confirmation-icon');
        const types = this.getAdaptedProducts().map((t) => getTourConfirmationType(t));
        if (tourConfirmationEl && isConfirmationTypeVisible(types)) {
            [this.confirmationVue] = new Vue({
                    render: (h) => h(ConfirmationTypeIcon, {
                        props: {
                            type: getToursConfirmationType(this.getAdaptedProducts()),
                            background: true,
                        },
                        nativeOn: {
                            click: (event) => {
                                event.preventDefault();
                            }
                        },
                    }),
                }).$mount(tourConfirmationEl).$children;
        }
    }

    initBonusMilesBadge() {
        const bonusMilesEl = this.el.querySelector('.hotelTour__footer-bonus-miles');
        if (bonusMilesEl) {
            const tourProducts = [this.model, ...(this.model.get('similarProducts') || [])]
                .filter(product => product.attributes?.type === ProductType.TourProduct);

            const hasBonusMiles = tourProducts.some((tour) => {
                const operator = tour.get('product')?.get('operator');
                return operator && filterByBonusMiles({ operator });
            });

            if (hasBonusMiles && !this.bonusMilesBadgeVue) {
                const bonusMilesContainer = document.createElement('div');
                bonusMilesEl.appendChild(bonusMilesContainer);

                [this.bonusMilesBadgeVue] = new Vue({
                    render: (h) => h(BonusMilesBadge, {
                        props: {
                            iconSpacing: 'medium',
                            iconVariant: 'grey',
                        }
                    }),
                }).$mount(bonusMilesContainer).$children;
            }
        }
    }

    initMirCashbackBadge() {
        if (!window?.appConfig?.vamPrivet) {
            return;
        }
        const mirCashbackEl = this.el.querySelector('.hotelTour__footer-mir-cashback');
        if (mirCashbackEl) {
            const products = [this.model, ...(this.model.get('similarProducts') || [])]
                .filter((product) => [
                    ProductType.TourProduct,
                    ProductType.HotelOfferProduct,
                ].includes(product.attributes?.type));

            const hasMirCashback = products.some((product) => {
                const operator = product.get('product')?.get('operator');
                const operatorId = operator?.id ?? operator?.get?.('id');
                return !!operatorId && filterByMirCashback({ operator: { id: operatorId } });
            });

            if (hasMirCashback) {
                const mirCashbackContainer = document.createElement('div');
                mirCashbackEl.appendChild(mirCashbackContainer);

                [this.mirCashbackBadgeVue] = new Vue({
                    render: (h) => h(MirCashbackBadge, {
                        props: {
                            iconSpacing: 'medium',
                            iconVariant: 'grey',
                        }
                    }),
                }).$mount(mirCashbackContainer).$children;
            }
        }
    }

    hotelOfferHandler() {
        let hotelOffers = [];
        if (this.model.get('type') === 'HotelOfferProduct') {
            hotelOffers.push(this.model);
        }
        hotelOffers = hotelOffers.concat(this.model.get('hotelOfferProducts'));

        this.collectionView.trigger('selectedHotelOfferGroup', {
            hotelOffers,
            tracking: this.getRoomProvidersTracking(),
        });
        this.hotelOfferStatistic();
        this.trackBeforeSearchFinishClick();
    }

    hotelOfferDirectCheckout(offer) {
        this.collectionView.trigger('hotelOfferDirectCheckout', {
            offerId: offer.offerId,
            price: offer.price,
            offerClickSent: this.getRoomProvidersTracking().offerClick(offer),
        });
    }

    trackBeforeSearchFinishClick() {
        const tourPageModel = this.collectionView?.model;
        this.hotelTrackingService.trackBeforeSearchFinishClick({
            products: tourPageModel?.get('syncTourProducts'),
            loadingState: tourPageModel?.get('loadingState'),
        });
    }

    railwayTourHandler() {
        let railwayTours = [];

        if (this.model.get('type') === 'RailwayTourProduct') {
            railwayTours.push(this.model);
        }
        railwayTours = railwayTours.concat(this.model.get('railwayProducts'));

        this.collectionView.trigger('selectedRailwayToursGroup', {
            railwayTours,
        });
    }

    tourSelectedOperators() {
        this.trackBeforeSearchFinishClick();
        const identity = this.model.get('id');
        const tour = this.model.get('tour');
        const { dataLayerAnalytics } = this.collectionView.parentView;
        const value = {};
        if (tour && tour.get('price')) {
            const toursGroup = this.viewModel.get('toursGroup');
            const timeStamp = new Date().toISOString();
            const hotelPageToursData = toursGroup.map((product) => ({
                id: product.get('id'),
                price: product.get('tour').get('priceWithOilTax'),
                isItPriceProvider: identity === product.get('id'),
                timeStamp,
            }));

            updateToursData(hotelPageToursData);
            ls.set(this.model.get('id'), tour.get('priceWithOilTax'));
            const minPriceBySearchDates = this.collectionView.parentView.model.get('minPriceBySearchDates');
            this.hotelTrackingService.trackHotelJumpBetweenCacheAndSearch(minPriceBySearchDates);
            this.hotelTrackingService.clickTourButtonWithConfirmation(getToursConfirmationType(this.getAdaptedProducts()));
        }
        value.prop1 = dataLayerAnalytics.createRangeEvent(this.getPropertyForTourClick());
        value.prop2 = [{ type: 'identity', id: identity }];
        dataLayerAnalytics.generateEvent('hotelClick', value);
    }

    render() {
        this.generateTemplate();
        this.collectionView.model.trigger('change');
        this.renderPartialPaymentBanner();
        const shouldRender = this.model.get('product');
        if (shouldRender) {
            const objectTourProductForRender = generateObjectToutProductFromRender(this);
            this.model.set({
                objectTourProductForRender,
            });
            this.$el.html(this.template(objectTourProductForRender));
            this.initViews();
            this.initVueComponents();
            this.applyBindings();
            this.initViewsAfterRender();
            this.initConfirmation();
            this.initBonusMilesBadge();
            this.initMirCashbackBadge();
        }
    }

    renderPartialPaymentBanner() {
        const tour = this.model.get('tour');
        const percentPaymentDefinition = this.model
            ?.get('firstPaymentDefinition')
            ?.firstPaymentPart;

        if (percentPaymentDefinition) {
            tour?.set({
                percentValue: percentPaymentDefinition,
            });
        }
    }

    partnerScriptCall() {
        if (this.collectionView) {
            sociomanticManager.notifyHotelPage(this.model, this.collectionView.model.get('searchData'));

            ecommerceService.productClickHotel({
                product: this.model,
                category: 'tour',
                pageType: 'tour',
                departureCityName: this.collectionView.model.get('searchData').get('departureCity').get('name'),
                collection: this.collectionView.collection,
            });
        }

        
    }

    generateTemplate() {
        this.template = tourProductComponentTemplate;
    }

    getPropertyForTourClick() {
        const hotelId = window.appConfig.hotelInfo.id;
        const tour = this.model.get('tour');

        return getPropertyForTourClick({ tour, hotelId });
    }

    initViews() {
        const model = this.model.get('product');
        new SimilarToursSelectDesktop({
            el: this.$el.find('.js-similar-tours'),
            model: this.model,
            gotoTourPage: this.tourSelectedOperators,
            controllerModel: this.collectionView.model,
        });

        new RoomCategoryPhotos({
            model,
            rootView: this.collectionView,
            el: $('.js-room-category-photos', this.$el),
        });
    }

    initVueComponents() {
        const isExclusive = this.model.get('isExclusive');
        if (isExclusive) {
            this.IsExclusiveBlockVueComponent = new IsExclusiveBlock({
                el: $('.js-isExclusive-tours', this.$el).get(0),
                propsData: {
                    isExclusive,
                    text: 'Лучшая цена',
                },
            });
        }

        this.initRoomProviders();
        this.initHotelOfferChevron();
        this.initFreeCancellationLabel();
    }

    initFreeCancellationLabel() {
        const container = $('.js-free-cancellation-label', this.$el).get(0);
        if (!container) return;

        if (this.freeCancellationLabelVue) {
            container.replaceWith(this.freeCancellationLabelVue.$el);
            return;
        }

        this.freeCancellationLabelVue = new Vue({
            render: (h) => h(FreeCancellationLabel),
        }).$mount(container);
    }

    initHotelOfferChevron() {
        const chevronEl = $('.js-hotel-offer-chevron', this.$el).get(0);
        if (!chevronEl) return;

        if (this.hotelOfferChevronVue) {
            chevronEl.replaceWith(this.hotelOfferChevronVue.$el);
            return;
        }

        this.hotelOfferChevronVue = new Vue({
            render: (h) => h(Icon, { props: { name: IconName.ChevronDown, size: 'm' } }),
        }).$mount(chevronEl);
    }

    getRoomProviderOffers() {
        const hotelOfferProducts = this.model.get('hotelOfferProducts') || [];
        const hotelOffers = [
            this.model.get('hotelOffer'),
            ...hotelOfferProducts.map((product) => product.get('hotelOffer')),
        ].filter(Boolean);

        return buildProviderOffers(hotelOffers);
    }

    getRoomProviders() {
        return buildRoomProviders(this.getRoomProviderOffers());
    }

    getRoomProvidersTracking() {
        if (!this.roomProvidersTracking) {
            this.roomProvidersTracking = createRoomProvidersTracking({
                productType: this.model.get('type'),
                getProduct: () => this.model.get('product'),
                getProviders: () => this.getRoomProviders(),
                getSearchIds: () => ({
                    hsid: searchSessionService.getHotelSearchId(),
                    sid: searchSessionService.getSearchId(),
                }),
            });
        }
        return this.roomProvidersTracking;
    }

    initRoomProviders() {
        const container = $('.js-room-providers', this.$el).get(0);
        if (!container) return;

        const roomId = this.model.get('id');
        let state = roomProvidersRegistry.get(roomId);
        if (!state) {
            state = { visible: false };
            roomProvidersRegistry.set(roomId, state);
        }
        this.roomProvidersState = state;

        if (this.roomProvidersView) {
            container.replaceWith(this.roomProvidersView.$el);
        } else {
            const view = this;
            const offers = this.getRoomProviderOffers();
            this.roomProvidersView = new Vue({
                name: 'RoomProvidersCard',
                data: { visible: state.visible },
                render(h) {
                    if (!this.visible) return null;
                    return h(RoomProviders, {
                        props: { offers },
                        on: {
                            book: () => view.hotelOfferHandler(),
                            checkout: (offer) => view.hotelOfferDirectCheckout(offer),
                            'offer-click': (offer) => view.getRoomProvidersTracking().offerClick(offer),
                            'modal-confirm': (offer) => view.getRoomProvidersTracking().modalConfirm(offer),
                            'modal-dismiss': (offer) => view.getRoomProvidersTracking().dismissPartnerModal(offer),
                            'trust-tooltip-open': () => view.getRoomProvidersTracking().trustTooltipOpen(),
                            'trust-tooltip-close': () => view.getRoomProvidersTracking().trustTooltipClose(),
                            'more-suppliers-open': () => view.getRoomProvidersTracking().moreSuppliers(),
                        },
                    });
                },
            }).$mount(container);
        }
        this.setRoomProvidersToggleLabel(this.roomProvidersView.visible);
        this.setHotelOfferChevronState(this.roomProvidersView.visible);
        this.observeRoomProvidersImpression();
    }

    observeRoomProvidersImpression() {
        if (!this.roomProvidersView?.visible) return;
        this.roomProvidersView.$nextTick(() => {
            const providersListElement = this.roomProvidersView.$el?.querySelector('.room-providers__list');
            this.getRoomProvidersTracking().observeImpression(
                providersListElement,
                !!this.roomProvidersState.impressionSent,
                () => { this.roomProvidersState.impressionSent = true; },
            );
        });
    }

    setRoomProvidersToggleLabel(visible) {
        const isHotelOffer = this.model.get('type') === ProductType.HotelOfferProduct;
        const showLabel = isHotelOffer ? 'Показать предложения' : 'Варианты только отеля';
        const hideLabel = isHotelOffer ? 'Скрыть предложения' : 'Скрыть варианты только отеля';
        $('.js-hotel-offer-handler .js-hotel-offer-toggle-label', this.$el)
            .text(visible ? hideLabel : showLabel);
    }

    hasOnlyTravelataProviders() {
        const providers = this.getRoomProviders();
        return providers.length > 0 && providers.every((provider) => isTravelataOperatorId(provider.operatorId));
    }

    setHotelOfferChevronState(visible) {
        $('.hotelTour__hotel-offer-price', this.$el).toggleClass('hotelTour__hotel-offer-price_opened', visible);
    }

    toggleRoomProviders() {
        if (!this.roomProvidersView) return;

        const isOpening = !this.roomProvidersView.visible;
        if (isOpening && this.hasOnlyTravelataProviders()) {
            this.hotelOfferHandler();
            return;
        }

        this.roomProvidersView.visible = !this.roomProvidersView.visible;
        this.roomProvidersState.visible = this.roomProvidersView.visible;
        this.setRoomProvidersToggleLabel(this.roomProvidersView.visible);
        this.setHotelOfferChevronState(this.roomProvidersView.visible);

        if (this.roomProvidersView.visible) {
            this.getRoomProvidersTracking().roomBlockOpen();
            this.observeRoomProvidersImpression();
        } else {
            this.getRoomProvidersTracking().roomBlockClose();
        }
    }

    remove() {
        this.roomProvidersTracking?.disconnect();
        this.roomProvidersView?.$destroy();
        this.hotelOfferChevronVue?.$destroy();
        this.freeCancellationLabelVue?.$destroy();
        return super.remove();
    }

    initViewsAfterRender() {
        new TooltipPopoverHtml({
            el: $('.js-product-type-tour', this.$el),
        });

        new TooltipPopoverHtml({
            el: $('.js-product-type-railway-tour', this.$el),
        });

        new TooltipPopoverHtml({
            el: $('.js-product-type-hotel', this.$el),
        });
        new TooltipPopoverHtml({
            el: $('.js-warranted-icon-tour', this.$el),
            position: 'bottom',
            positionHorizontal: 'right',
        });
        new TooltipPopoverHtml({
            el: $('.js-warranted-icon-hotel', this.$el),
            position: 'bottom',
            positionHorizontal: 'right',
        });
    }
}
